export const TABLEHEADERSPUNCTUALTRANSACTIONS = [
  {
    name: 'date',
    displayName: 'transactions.Date',
    type: 'date',
  },
  {
    name: 'category',
    displayName: 'transactions.Category',
    type: 'string',
  },
  {
    name: 'description',
    displayName: 'transactions.Description',
    type: 'string',
  },
  {
    name: 'amount',
    displayName: 'transactions.Amount',
    type: 'number',
  },
];

export const TABLEHEADERSPTRANSACTIONSHEADERS = [
  {
    name: 'startAt',
    displayName: 'transactions.startAt',
    type: 'date',
  },
  {
    name: 'each',
    displayName: 'transactions.each',
    type: 'days',
  },
  {
    name: 'endAt',
    displayName: 'transactions.endAt',
    type: 'date',
  },
  {
    name: 'description',
    displayName: 'transactions.Description',
    type: 'string',
  },
  {
    name: 'amount',
    displayName: 'transactions.Amount',
    type: 'number',
  },
];

export const ACTIONSPUNCTUAL = {
  title: 'transactions.action',
  add: 'transactions.addPunctual',
  edit: 'transactions.edit',
  delete: 'transactions.delete',
};

export const ACTIONSPERIODIC = {
  title: 'transactions.action',
  add: 'transactions.addPeriodic',
  edit: 'transactions.edit',
  delete: 'transactions.delete',
};

export const TITLETABLETRANSACTIONS = 'transactions.past';
export const TITLETABLEPERIODICTRANSACTIONS = 'transactions.periodic';
